import type { FormRequest } from '../../../types/forms'

export const toDate = (value: FormRequest['requestedAt']): Date | null => {
  if (!value) return null
  if (value instanceof Date) return value
  if (typeof (value as { toDate?: () => Date }).toDate === 'function') return (value as { toDate: () => Date }).toDate()
  return null
}

export const isFormRequestOverdue = (request: FormRequest, now = Date.now()) => {
  if (request.status !== 'PENDING') return false
  const due = toDate(request.expiresAt)
  return Boolean(due && due.getTime() < now)
}
